import './basic-content-main.scss';

import { cn } from '@sola/ark-core/utils/helpers.ts';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';

import { Image } from '../../../atoms/image/image.tsx';
import { Video } from '../../../atoms/video/video.tsx';
import { Card } from '../../../molecules/card/card.tsx';
import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { FeatureButtons } from '../../../molecules/feature-buttons/feature-buttons.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';

export const BasicContentMain: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  badge,
  icon,
  media,
  quotation: _quotation,
  primaryCTA,
  secondaryCTA,
  tertiaryCTA,
  alt,
  inline,
  ...props
}) => {
  const hasButtons = !!primaryCTA || !!secondaryCTA || !!tertiaryCTA;
  return (
    <section
      className={cn('BasicContentMain component component--container', {
        'BasicContentMain--alt': alt,
      })}
    >
      <div className="BasicContentMain__container container">
        <div
          className={cn('BasicContentMain__flex flex flex-col', {
            '@md:flex-row-reverse': !alt,
            '@md:flex-row @md:items-center': alt,
          })}
        >
          {!alt && (
            <aside className="BasicContentMain__sidebar">
              <div className="BasicContentMain__media">
                <Card
                  {...{ media, badge, icon }}
                  seoLevel={seoLevel + 1}
                  variant="background"
                  className="aspect-ratio-3-4"
                  hasPlaceholder
                />
              </div>
            </aside>
          )}

          <div className="BasicContentMain__content">
            <div
              className="w-full max-w-md gap-comfy-xl grid"
              style={{ width: '100%' }}
            >
              <FeatureBase
                {...props}
                {...getBaseSizeProps(seoLevel, inline)}
                {...(!badge && { icon })}
                seoLevel={seoLevel}
                className="@lg:pr-comfy-xl"
                inline
              />

              {media && (
                <div className="BasicContentMain__media">
                  {media.image && !media.video?.url && (
                    <Image
                      aspectRatio="16-9"
                      image={media.image}
                      rounded="lg"
                      priority={seoLevel === 1}
                    />
                  )}
                  {media.video?.url && <Video url={media.video.url} />}
                  {media.caption && (
                    <div className="label label-lg mt-comfy-sm">
                      <p>{media.caption}</p>
                    </div>
                  )}
                </div>
              )}

              {hasButtons && (
                <FeatureButtons
                  {...{ primaryCTA, secondaryCTA, tertiaryCTA }}
                  alignment="left"
                  inline
                />
              )}
            </div>
          </div>

          {alt && (
            <aside className="BasicContentMain__sidebar BasicContentMain__sidebar--alt">
              <div className="BasicContentMain__media justify-self-center @md:justify-self-end">
                <Card
                  {...{ media, badge, icon }}
                  seoLevel={seoLevel + 1}
                  variant="background"
                  className="aspect-ratio-1"
                  hasPlaceholder
                />
              </div>
            </aside>
          )}
        </div>
      </div>
    </section>
  );
};
